<div [ngClass]="{'expand': gamesSearch?.showPopup, 'mobile': gamesSearch?.showPopup && breakPoint?.isMobile}"
  class="search-container" ClickOutside (clickOutside)="onClosePopup()"
  [options]="{ignoreOutsideComponents: ['.search', '.search-sticky']}">
  @if (gamesSearch?.showPopup && breakPoint?.isMobile) {
    <div class="search-container__search-title">
      {{'btn.search' | translate}}
    </div>
  }
  <i (click)="gamesSearch.togglePopup()" class="icon-close"></i>
  <div class="search-container__inner">
    <div class="container">
      <div class="search-container__search">
        <app-games-search></app-games-search>
        <app-games-filter></app-games-filter>
      </div>
      <app-games-search-bar></app-games-search-bar>
    </div>
    <app-games-filter-bar
      (cancel$)="onCancelFilter()"
      (submit$)="onSubmitFilter()">
    </app-games-filter-bar>
  </div>
</div>
